import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface EmptyProps {
  className?: string;
  title: string;
  icon: ReactNode;
  text?: string;
  description?: string;
}

export const Empty = (props: EmptyProps) => {
  const { t } = useTranslation();

  const caption = props.text ?? t('empty.title', { title: props.title });
  return (
    <div
      className={clsx(
        'flex items-center justify-center text-center flex-col md:py-[243px] md:px-[100px] pt-[76px] px-[47px] pb-[95px]',
        props.className,
      )}
    >
      {props.icon}
      <h1 className='mt-4 mb-2.5 mx-0 font-bold leading-1.6 text-[#27272b] uppercase text-center text-base font-semibold'>{caption}</h1>
      {props.description ? (
        props.description
      ) : (
        <p className='text-center w-[457px] font-[500] text-[#616164] leading-1.25 m-0 md:text-[16px] text-[14px]'></p>
      )}
    </div>
  );
};
